import React from 'react';
import { GoogleMap, useJsApiLoader, Marker } from '@react-google-maps/api';
import styles from './IceCreamMap.module.scss';
import { config } from '../../config';

const { GOOGLE_MAP_KEY } = config;
const mapContainerStyle = {
  width: '100%',
  height: '100%',
  minHeight: '380px',
};

const iceCreamLocation = { lat: -6.215773812785213, lng: 106.8177228395333 };

const IceCreamMap = () => {
  const { isLoaded } = useJsApiLoader({
    id: 'icecream-map',
    googleMapsApiKey: GOOGLE_MAP_KEY || '',
  });

  return isLoaded ? (
    <div className={styles.map}>
      <GoogleMap
        mapContainerStyle={mapContainerStyle}
        center={iceCreamLocation}
        zoom={15}
      >
        <Marker
          position={iceCreamLocation}
        />
      </GoogleMap>
    </div>
  ) : <></>;
};

export default React.memo(IceCreamMap);
